import React, { useState } from "react";
import axios from 'axios';
import CustomDropdown from "./dropdown";
function Note({setLoading}) {
    const [response, setResponse] = useState(null);
    const [title, setTitle] = useState("");
    const options = [
        
            ['AP Literature & Composition', 'LIT'],
            ['AP Physics C', 'PHYSICS'],
            ['Biotech Honors', 'BIO'],
            ['Cabinetry and Furniture Design', 'WOOD'],
            ['Calculus 3H', 'MULTI'],
            ['Economics', 'ECON'],
            ['GT', 'GT'],
            ['Product Engineering & Design', 'PED'],
            // ['Testing', 'TEST']
        
    ]
    const [folder, setFolder] = useState(options[0][1]);
    const [folderString, setFolderString] = useState(options[0][0])
    const [url, setUrl] = useState("")
    const googleDoc = () => {
        window.open(url, "_blank")

    }
    const handleSubmit = async () => {
        setLoading(true)
        const date = new Date();
        const formattedDate = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).replace(/\//g, '.');
        const data = {
            action: 'create_note',
            folder: folder,
            title: title,
            key: process.env.REACT_APP_customApiKey,
            date: formattedDate
        }
        const URL = process.env.REACT_APP_API_URL + '/api'
        try {
            const res = await axios.post(URL, data);
            setUrl(res.data.link)
            setResponse(title + " Notes")
            setTitle("")
          } catch (error) {
            console.error('Error:', error);
          }
          setLoading(false)
        
                
    };
    return <div className="shadow-lg rounded-sm w-full p-3 min-w-min">
        <h1 className="text-xl md:text-3xl text-black font-bold">Note Creator</h1>
        <div className="flex flex-col gap-1 text-left" >
            <p className="text-black text-base md:text-xl font-light my-2">Note Title</p>
            <input className="p-2 text-red-500 " value={title} onChange={(e) => setTitle(e.target.value)} />
        </div>
        <div className="flex flex-col gap-1 text-left" >
            <p className="text-black text-base md:text-xl font-light my-2">Folder</p>
            <CustomDropdown
            options={options}
            selected={folder}
            setSelected={setFolder}
            selectedString={folderString}
            setSelectedString={setFolderString}
            />
        
        </div>
        {response && <p className="text-red-500 cursor-pointer underline mt-2" onClick={googleDoc}>{response}</p>}

    <button onClick={handleSubmit} className="outline text-sm md:text-base outline-red-500 outline-2 bg-red-500 text-white duration-300 hover:bg-white hover:text-red-500 p-2 rounded-lg mt-4 ">Create Notes</button>
    </div>
}
export default Note;